<script setup lang="ts">
import { useColorMode } from '@/composables/useSharedColorMode';
import { KaButton } from '@/kasten-components';
import IconMoon from '~icons/lucide/moon';
import IconSun from '~icons/lucide/sun';

const mode = useColorMode();
</script>

<template>
  <KaButton
    class="h-10 bg-transparent p-2 text-gray-700 shadow-none ring-0 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline-offset-0 dark:bg-transparent dark:text-gray-400 dark:ring-0 dark:hover:bg-navy-800 dark:hover:text-gray-50"
    @click="mode = mode === 'dark' ? 'light' : 'dark'"
  >
    <IconSun
      class="absolute size-5 rotate-90 scale-0 transition dark:rotate-0 dark:scale-100"
      aria-hidden="true"
    />
    <IconMoon
      class="size-5 rotate-0 scale-100 transition dark:-rotate-90 dark:scale-0"
      aria-hidden="true"
    />
    <span class="sr-only">Enable {{ mode === 'dark' ? 'Light' : 'Dark' }} Mode</span>
  </KaButton>
</template>
